import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Pagination from '@material-ui/lab/Pagination';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

/** hooks */
import { formatPlate } from 'utils';
import { useHttp } from '../../hooks/http';

/** Componentes */
import Layout from '../../components/Layout';
import HeaderFilterPlus from '../../components/Headers/FilterPlus';
import Flex, { Grid } from '../../components/Flex';
import Card, { CardHeader, CardContent } from '../../components/Card';
import {
  Menu, MenuItem, DotButton, ItemIcon,
} from '../../components/CustomMenu';

import {
  PoliceCarFill, PencilIcon, BlockIcon,
} from '../../styles/icons';

/** interfaces */
import { IFleet, IResponse } from '../../interfaces';

import {
  Container, WrapperPaginate, WrapperName,
} from './styles';

const breadcrumbs = {
  icon: PoliceCarFill,
  links: [
    { title: 'Viaturas', path: '' },
  ],
};

interface FleetData extends IResponse {
    data: IFleet[];
}

const Fleet: React.FC = () => {
  const [fleets, setFleets] = useState<FleetData>({} as FleetData);
  const [filter, setFilter] = useState('');
  const history = useHistory();
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(6);
  const [lastPage, setLastPage] = React.useState(1);

  const { httpGet, loading } = useHttp();

  useEffect(() => {
    async function loadFleets(): Promise<void> {
      const response = await httpGet('fleets', {
        params: {
          page,
          perPage,
          filter,
        },
      });
      if (response.data) {
        setFleets(response.data);
        setPerPage(response.data.pagination.perPage);
        setLastPage(response.data.pagination.lastPage);
      }
    }

    loadFleets();

    }, [filter, page, perPage]); // eslint-disable-line

  const handleSearch = (value: string): void => {
    setPage(1);
    setFilter(value);
  };

  const handlePaginate = (event: React.ChangeEvent<unknown>, value: number): void => {
    setPage(value);
  };

  const handleGoToEdit = (id: string): void => {
    history.push(`/fleet/${id}`);
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>

        <HeaderFilterPlus
          handleSearch={handleSearch}
          handlePlus={() => history.push('/fleet')}
        />

        <Grid container justify="flex-start" spacing={1}>
          {fleets?.data?.map((fleet) => (
            <Grid item key={fleet.id} xs={12} sm={6} md={6}>
              <Card>
                <CardHeader>
                  <WrapperName>
                    {fleet?.status_vehicle
                      ? <><PoliceCarFill /><p> {fleet?.plate}</p></>
                      : <><BlockIcon /><span> {fleet?.plate}</span></>}
                  </WrapperName>
                  <PopupState variant="popover" popupId="demo-popup-menu">
                    {(popupState) => (
                      <>
                        <DotButton {...bindTrigger(popupState)} />
                        <Menu {...bindMenu(popupState)}>
                          <MenuItem
                            onClick={() => { handleGoToEdit(fleet?.id); }}
                            style={{ width: 150 }}
                          >
                            <ItemIcon icon={<PencilIcon />} title="Editar" />
                          </MenuItem>
                        </Menu>
                      </>
                    )}
                  </PopupState>
                </CardHeader>
                <CardContent>
                  <Grid container spacing={1}>
                    <Flex title="Placa" xs={6} sm={6} md={4}>
                      {formatPlate(fleet?.plate)}
                    </Flex>
                    <Flex title="Placa especial" xs={6} sm={6} md={4}>
                      {fleet?.special_plate ? formatPlate(fleet?.special_plate) : 'não informado'}
                    </Flex>
                    <Flex title="Marca/Modelo" xs={6} sm={6} md={4}>
                      {fleet?.make.name} / {fleet?.model.name}
                    </Flex>
                    <Flex title="Combustível" xs={6} sm={6} md={4} textAutoSize>
                      {fleet?.fuel}
                    </Flex>
                    <Flex title="Cor" xs={6} sm={6} md={4}>
                      {fleet?.color}
                    </Flex>
                    <Flex title="Gerência" xs={6} sm={6} md={4}>
                      {fleet?.management?.initials}-{fleet?.management?.name}
                    </Flex>
                    <Flex title="Status" xs={6} sm={6} md={4}>
                      {fleet?.status_vehicle
                        ? 'Ativa'
                        : 'Bloqueada'}
                    </Flex>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <WrapperPaginate>
          <Pagination count={lastPage} page={page} onChange={handlePaginate} />
        </WrapperPaginate>
      </Container>
    </Layout>
  );
};

export default Fleet;
